import { render, staticRenderFns } from "./AvatarTask.vue?vue&type=template&id=66daa562&scoped=true&"
import script from "./AvatarTask.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarTask.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66daa562",
  null
  
)

export default component.exports